enum EProviderType {
  Internal = 'internal',
  External = 'external',
}

export default EProviderType;
